import React from "react";
import { Container, Header, Icon } from "semantic-ui-react";
import "./Page_UIMaterials.scss";
import "./Page_UIMaterials_IpartirRutas.scss";

export function Page_UIMaterials() {
  return (
    <Container className="ui-materials">
      {/* Secciones iniciales con textos y barras de color a la izquierda */}
      <div className="intro-sections">
        {/* 1) Diseña tu Ruta de Aprendizaje */}
        <div className="intro-section">
          <h2 className="intro-title">Diseña tu Ruta de Aprendizaje</h2>
          <p className="intro-description">
            Personaliza una ruta educativa seleccionando aulas, contextos,
            agentes IA y recursos para tus estudiantes.
          </p>
          <hr className="intro-divider" />
        </div>

        {/* 2) Filtro de Aulas disponibles */}
        <div className="intro-section">
          <h2 className="intro-title">Filtro de Aulas disponibles</h2>
          <p className="intro-description">
            Selecciona la categoría y descubre todo el contenido que puedes
            añadir a tus rutas.
          </p>
          <hr className="intro-divider" />
        </div>

        {/* 3) Listado de Rutas Creadas (fuentes más pequeñas) */}
        <div className="intro-section rutas-creadas">
          <h2 className="intro-title">Listado de Rutas Creadas</h2>
          <p className="intro-description">
            Revisa tus rutas, aulas y alumnos.
          </p>
          <hr className="intro-divider" />
        </div>
      </div>

      {/* Encabezado existente */}
      <Header as="h1" textAlign="center">
        UI Materials
      </Header>

      {/* Sección de botones generales */}
      <section className="section-buttons">
        <Header as="h2">General Buttons</Header>
        <div className="buttons-group">
          <button className="e-button-primary">Primary Button</button>
          <button className="e-button-secondary">Secondary Button</button>
          <button className="e-button-basic">Basic Button</button>
        </div>
      </section>

      {/* ====================================== */}
      {/* Sección: Categorías y sub-categorías  */}
      {/* ====================================== */}
      <section className="section-buttons">
        <Header as="h2">Categorias y sub-categorías</Header>

        {/* 1) Botones "Todas" y "Propias" en gris oscuro */}
        <div className="buttons-group">
          <button className="e-button-categories e-button-todas">Todas</button>
          <button className="e-button-categories e-button-propias">
            Propias
          </button>
        </div>

        {/* 2) Botones de categorías (ya existentes) */}
        <div className="buttons-group">
          <button className="e-button-categories e-button-humanas">
            CienciasHumanas
          </button>
          <button className="e-button-categories e-button-naturales">
            CienciasNaturales
          </button>
          <button className="e-button-categories e-button-historia">
            Historia
          </button>
          <button className="e-button-categories e-button-matematicas">
            Matemáticas
          </button>
          <button className="e-button-categories e-button-arte">Arte</button>
          <button className="e-button-categories e-button-vida-saludable">
            VidaSaludable
          </button>
        </div>

        {/* 3) Botón "Subcategorias" en gris más claro */}
        <div className="buttons-group">
          <button className="e-button-subcategories">Subcategorias</button>
        </div>
      </section>
      {/* ====================================== */}

      {/* Sección de botones específicos */}
      <section className="section-buttons">
        <Header as="h2">Otros botones</Header>
        <div className="buttons-group">
          <button className="e-button-info">
            <Icon name="eye" />
          </button>
          <button className="e-button-list">
            <Icon name="list" />
          </button>
          <button className="e-button-enter">
            <Icon name="sign-in" />
          </button>
          <button className="e-button-trash">
            <Icon name="trash" />
          </button>
        </div>
      </section>

      {/* Sección de cards */}
      <section className="section-cards">
        <Header as="h2">Cards</Header>
        <div className="cards-group">
          {/* e-card-scene con el nuevo diseño */}
          <div className="e-card-scene">
            {/* Imagen superior (banner) */}
            <img
              className="card-banner"
              src="https://storage.googleapis.com/educa360-legacy-assets/legacy/repopublic-educa360-central/adminweb/virtualscenes/05-06-010-LEONARDODAVINCI/Vista%20de%20la%20sala%20virtual/1728037346926_LEONARDODAVINCI01.jpg"
              alt="Banner Scene"
            />
            {/* Contenido de la card */}
            <div className="card-body">
              <p className="card-createdby">Creado por: Educa360</p>

              {/* Dos círculos de colores */}
              <div className="card-circles">
                <div className="circle circle--blue"></div>
                <div className="circle circle--green"></div>
                <h4 className="card-subcategorie">Edad Media Edad Antigua</h4>
              </div>

              {/* Título */}
              <h3 className="card-title">La capilla Sixtina</h3>

              {/* Línea separadora */}
              <hr className="card-divider" />

              {/* Botones con íconos */}
              <div className="card-actions">
                <button className="btn-icon">
                  <Icon name="eye" />
                </button>
                <button className="btn-icon">
                  <Icon name="list" />
                </button>
                <button className="btn-add-route">
                  <Icon name="sign-in" />
                  Añadir Ruta
                </button>
              </div>
            </div>
          </div>

          {/* Rutas */}
          <div className="e-card-rute">
            <div className="rute-info">
              <h3 className="rute-title">Ruta Historia</h3>
              <p className="rute-assigned">Asignado a 1ºA</p>
              <div className="rute-buttons">
                <button className="e-button-info">
                  <Icon name="eye" />
                </button>
                <button className="e-button-info">
                  <Icon name="list" />
                </button>
                <button className="e-button-info">
                  <Icon name="trash" />
                </button>
              </div>
            </div>

            <div className="rute-image">
              <img
                src="https://storage.googleapis.com/educa360-legacy-assets/legacy/repopublic-educa360-central/adminweb/virtualscenes/05-06-010-LEONARDODAVINCI/Vista%20de%20la%20sala%20virtual/1728037346926_LEONARDODAVINCI01.jpg"
                alt="Rute"
              />
            </div>
          </div>
          {/* Alumnos */}
          <div className="e-card-student-compact">
            {/* Avatar a la izquierda */}
            <div className="student-avatar">
              <img
                src="https://storage.googleapis.com/educa360-legacy-assets/legacy/repopublic-educa360-central/adminweb/virtualscenes/05-06-010-LEONARDODAVINCI/Vista%20de%20la%20sala%20virtual/1728037346926_LEONARDODAVINCI01.jpg"
                alt="Alumno"
              />
            </div>

            {/* Info (nombre, subtítulo) en el centro */}
            <div className="student-info">
              <h3 className="student-name">Alumno de prueba1</h3>
              <p className="student-desc">Alumno en clase</p>
            </div>

            {/* Círculo de estado a la derecha */}
            <div className="student-status-dot circle--blue"></div>
          </div>
        </div>

        {/* Rutas */}
        <div className="e-card-rute-enter">
          <div className="rute-info">
            <h3 className="rute-title">Ruta Historia</h3>
            <p className="rute-assigned">Asignado a 1ºA</p>
            <div className="rute-buttons">
              <button className="e-button-info">
                <Icon name="list" />
              </button>
              <button className="btn-add-route-enter">
                <Icon name="sign-in" />
                Entrar
              </button>
            </div>
          </div>

          <div className="rute-image">
            <img
              src="https://storage.googleapis.com/educa360-legacy-assets/legacy/repopublic-educa360-central/adminweb/virtualscenes/05-06-010-LEONARDODAVINCI/Vista%20de%20la%20sala%20virtual/1728037346926_LEONARDODAVINCI01.jpg"
              alt="Rute"
            />
          </div>
        </div>
      </section>
    </Container>
  );
}
